import React, { FC } from 'react';

import { useTheme } from '@mui/material';

import { Svg } from '~/assets/icons/styles';
import { OneColorIconProps } from '~/assets/icons/types';

const ExpandRoundedIcon: FC<OneColorIconProps> = ({ color, ...rest }) => {
  const theme = useTheme();
  const svgColor = color || theme.palette.common.primary;

  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={svgColor}
      {...rest}
    >
      <path
        d="M11 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 2.99922L21 8.75922M21 2.99922L15.15 2.99922M21 2.99922L16.95 7.04922L14.925 9.07422"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default ExpandRoundedIcon;
